import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import TrackingSales from "../../../containers/modules/report/tracking-sales";

export default function TrackingSalesRoutes(props) {
  const { authUser } = props;
  return (
    <Route
      path="tracking-sales"
      index
      element={
        <AccessControl
          name={"Report Tracking Sales"}
          auth={authUser}
          component={() => <TrackingSales />}
        />
      }
    ></Route>
  );
}
